<template lang="pug">
  section.dashboard-main
    .columns.is-multiline.is-centered
      reminders(v-if="checkVisibility('expense', 'view')")
      expenses-due(v-if="checkVisibility('expense', 'view')")
      expenses-waiting(v-if="checkVisibility('expense', 'view')")
      expenses-advance(v-if="checkVisibility('expense', 'view')")
      revenues-due(v-if="checkVisibility('revenue', 'view')")
      revenues-waiting(v-if="checkVisibility('revenue', 'view')")
      yields-due(v-if="checkVisibility('yield', 'view')")
      .column.is-11(v-if="!checkVisibility('expense', 'view') && !checkVisibility('revenue', 'view')")
        .hero.is-fullheight
          .hero-body
            .container
              h1.title Bem-vindo!
              h2.subtitle ao ERP - THEPES!
</template>

<script>
  import DataNotification from './components/DataNotification'
  import Reminders from './components/Reminders'
  import ExpensesDue from './components/ExpensesDue'
  import ExpensesWaiting from './components/ExpensesWaiting'
  import ExpensesAdvance from './components/ExpensesAdvance'
  import RevenuesDue from './components/RevenuesDue'
  import RevenuesWaiting from './components/RevenuesWaiting'
  import YieldsDue from './components/YieldsDue'

  import AuthService from '@/services/auth.js'

  export default {
    name: 'Dashboard',
    components: {
      DataNotification,
      Reminders,
      ExpensesDue,
      ExpensesWaiting,
      ExpensesAdvance,
      RevenuesDue,
      RevenuesWaiting,
      YieldsDue
    },
    data () {
      return {}
    },
    methods: {
      checkVisibility (resource, value) {
        return AuthService.checkPermissionSync(resource, value)
      }
    }
  }
</script>

<style scoped lang="sass">
  .dashboard-main
    min-height: 80vh
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// Dashboard.vue?a6a34b8a